import { Result } from '@core/models/common.model';

export function extractContent<T>(response: Result<{ content: T[] }>): T[] {
  if (response.success) {
    return Array.isArray(response.data?.content) ? response.data.content : [];
  }
  return [];
}

export function extractResponse<T>(response: Result<T>): T | null {
  return response.success ? response.data : null;
}

export function extractTotalElements(response: Result<{ totalElements?: number }>): number {
  if (response.success && response.data) {
    return response.data.totalElements ?? 0;
  }
  return 0;
}
